import React from 'react';
import { ToastContainer as ToastifyContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.min.css';
import './ToastifyStyleOverrides.scss';

const ToastContainer: React.FC = () => {
    return (
        <ToastifyContainer
            position={toast.POSITION.BOTTOM_LEFT}
            hideProgressBar
            closeOnClick={false}
            draggable={false}
            autoClose={5000}
            theme="colored"
        />
    );
};

export default ToastContainer;
